import { StatColumn } from "@bridgesplit/ui";
import { combineCollections } from "@bridgesplit/utils";

import { useHealthChangeStats, useTokenAmountStats } from "../../clmm/common";
import { useRaydiumContext } from "../RaydiumContext";
import { useWithdrawAmounts, useWithdrawLtv } from "./util";

export default function WithdrawCtaStats() {
    const { withdrawForm, raydiumPosition } = useRaydiumContext();
    const withdrawLtv = useWithdrawLtv();
    const healthChangeStats = useHealthChangeStats(withdrawLtv);
    const { tokenAAmount, tokenBAmount } = useWithdrawAmounts();

    const tokenAmountStats = useTokenAmountStats({
        tokenAChange: tokenAAmount ? tokenAAmount * -1 : 0,
        tokenBChange: tokenBAmount ? tokenBAmount * -1 : 0,
        tokenA: raydiumPosition.tokenA,
        tokenB: raydiumPosition.tokenB
    });

    if (!withdrawForm.percentToWithdraw || withdrawForm.percentToWithdraw > 1) return null;

    return (
        <StatColumn loading={withdrawLtv.isLoading} stats={combineCollections([tokenAmountStats, healthChangeStats])} />
    );
}
